var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.264,
    height: 7.902,
    viewBox: "0 0 12.264 7.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "right-arrow",
    d: "M8.094-9.078a.256.256,0,0,1,.438,0l3.609,3.609a.256.256,0,0,1,0,.438L8.531-1.422a.256.256,0,0,1-.437,0l-.547-.52a.281.281,0,0,1,0-.465L9.762-4.539H.328A.29.29,0,0,1,0-4.867v-.766a.29.29,0,0,1,.328-.328H9.762L7.547-8.094a.281.281,0,0,1,0-.465Z",
    transform: "translate(0 9.201)",
    fill: "#7f7f7f",
    opacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.613cf14ab6f5b8b6482844e42b10cbc1.svg";
export { ForwardRef as ReactComponent };